/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import {
  Modal, Label, Checkbox, Popup, List
} from 'semantic-ui-react';
import { v4 as uuidv4 } from 'uuid';
//import { observer } from 'mobx-react';
import Update from 'immutability-helper';
import { Scrollbars } from 'react-custom-scrollbars-2';
import cx from 'classnames';
import Loader from '../Loader/Loader';
import api from '../../api';
import closeBtn from '../../images/components/new_scan/close-btn.svg';
import userPic from '../../images/common/profile_icon_big.png';
import AssigningUserModal from './AssigningUserModal';
import AssigningProjectModal from './AssigningProjectModal';

class EditLocalGroupModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMEG: props.isOpenMEG,
      isOpenMAU: false,
      isOpenMAP: false,
      isLoading: false,
      modalAlert: false,
      viewPoint: '1',
      members: [],
      projects: [],
      membersDetail: [],
      projectsDetail: [],
      memberCheckValue: [],
      projectCheckValue: [],
      activeIndex: '',
      projectChecked: false,
      memberChecked: false,
      isNameChangeable: false,
      isDescChangeable: false,
      isMemberChangeable: false,
      isProjectAssignable: false,
      isGroupDeletable: false,
      popupStatus: {
        isMemberPopup: false,
        isProjectPopup: false,
      },
      id: '',
      source: '',
      groupName: '',
      description: '',
      created: '',
      lastModified: '',
    };
    this.getByteLength = this.getByteLength.bind(this);
    this.handleGroupNameChange = this.handleGroupNameChange.bind(this);
    this.handleMemberList = this.handleMemberList.bind(this);
    this.handleMAUClose = this.handleMAUClose.bind(this);
    this.handleProjectList = this.handleProjectList.bind(this);
    this.handleMAPClose = this.handleMAPClose.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleRemoveGroup = this.handleRemoveGroup.bind(this);
    this.handleViewPostion = this.handleViewPostion.bind(this);
    this.handleDescChange = this.handleDescChange.bind(this);
    this.handleRemoveMember = this.handleRemoveMember.bind(this);
    this.handleAddMember = this.handleAddMember.bind(this);
    this.handleGroupCheckAll = this.handleGroupCheckAll.bind(this);
    this.handleGroupCheckChange = this.handleGroupCheckChange.bind(this);
    this.handleRemoveProject = this.handleRemoveProject.bind(this);
    this.handleAddProject = this.handleAddProject.bind(this);
    this.handleProjectCheckAll = this.handleProjectCheckAll.bind(this);
    this.handleProjectCheckChange = this.handleProjectCheckChange.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.validateFields = this.validateFields.bind(this);
    this.deleteGroup = this.deleteGroup.bind(this);
    this.closeAlertModal = this.closeAlertModal.bind(this);
    this.closeDeleteGroupModal = this.closeDeleteGroupModal.bind(this);
    this.closeEditLocalGroupModal = this.closeEditLocalGroupModal.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    const { isOpenMEG } = this.props;

    if (isOpenMEG !== prevProps.isOpenMEG) {
      this.setState({
        isOpenMEG,
        groupName: '',
        description: '',
        members: [],
        projects: [],
        memberCheckValue: [],
        projectCheckValue: [],
        modalAlertMsg: '',
        modalAlertTitle: '',
        groupNameError: '',
        viewPoint: '1',
      }, () => {
        if (isOpenMEG) {
          this.getSLocalGroupDetail(this.props);
        }
      });
    }
  }

  handleDescChange(e) {
    this.setState({
      description: e.target.value,
    });
  }

  handleGroupNameChange(e) {
    this.setState({
      groupName: e.target.value,
      groupNameError: '',
    });
  }

  handleViewPostion(e) {
    if (e.currentTarget.dataset.id === '1') {
      this.groupNM.scrollIntoView();
    } else if (e.currentTarget.dataset.id === '2') {
      this.groupMB.scrollIntoView();
    }
    this.setState({
      viewPoint: e.currentTarget.dataset.id,
    });
  }

  handleMemberList(newArr) {
    const { members } = this.state;
    this.setState({
      members: Update(members, {
        $push: newArr,
      }),
    });
  }

  handleMAUClose() {
    this.setState({
      isOpenMAU: false,
    });
  }

  handleProjectList(newArr) {
    const { projects } = this.state;
    this.setState({
      projects: Update(projects, {
        $push: newArr,
      }),
    });
  }

  handleMAPClose() {
    this.setState({
      isOpenMAP: false,
    });
  }

  handleClose() {
    const status = {
      isMemberPopup: false,
      isProjectPopup: false,
    };
    this.setState({
      popupStatus: status,
      activeIndex: '',
    });
  }

  handleRemoveGroup() {
    this.setState({
      isOpenMDG: true,
    });
  }

  handleScroll = () => {
    this.handleClose();
  };

  handleSave(event) {
    event.preventDefault();
    const newMemberArr = [];
    const newProjectArr = [];
    const {
      id, groupName, description, members, projects
    } = this.state;
    const { translate } = this.props;

    members.map((item) => {
      return newMemberArr.push(item.email);
    });

    projects.map((item) => {
      return newProjectArr.push(item.id);
    });

    const formData = {
      name: groupName,
      description,
      members: newMemberArr,
      project_ids: newProjectArr,
    };

    if (!this.validateFields()) {
      return null;
    }

    this.setState({
      modalAlert: true,
      isLoader: true,
    });

    api
      .updateLocalGroupDetail(id, formData)
      .then(() => {
        this.setState({
          isLoader: false,
          modalAlertTitle: translate('modal.title.notice'),
          modalAlertMsg: translate('modal.message.group_update_success'),
        });
      })
      .catch((err) => {
        console.log(err);
        const o = err.data.response;
        if (o.error === '422-501') {
          return this.setState({
            isLoader: false,
            isLoading: false,
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: translate('modal.message.required_group_name'),
          });
        } if (o.error === '422-502') {
          return this.setState({
            isLoader: false,
            isLoading: false,
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: translate('modal.message.permitted_group_member'),
          });
        } if (o.error === '422-503') {
          return this.setState({
            isLoader: false,
            isLoading: false,
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: translate('modal.message.use_different_group_name'),
          });
        }
        if (o.error_description) {
          this.setState({
            isLoader: false,
            isLoading: false,
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: o.error_description,
          });
        } else {
          this.setState({
            isLoader: false,
            isLoading: false,
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: translate('modal.error.unknow_error'),
          });
        }
      });
  }

  handleAddMember() {
    this.setState({
      memberChecked: false,
      memberCheckValue: [],
      isOpenMAU: true,
    });
  }

  handleRemoveMember() {
    const { translate } = this.props;
    const { memberCheckValue, members } = this.state;
    if (memberCheckValue.length === 0) {
      this.setState({
        modalAlert: true,
        modalAlertMsg: translate('modal.message.select_one_member'),
        modalAlertTitle: translate('modal.title.attention'),
      });
      return false;
    }
    const newState = members.filter((item, index) => {
      return memberCheckValue.indexOf(index) === -1;
    });
    this.setState({
      members: newState,
      memberCheckValue: [],
    });
  }

  handleGroupCheckChange(e, { value }) {
    const { memberCheckValue } = this.state;
    let newState;
    if (memberCheckValue.indexOf(value) > -1) {
      newState = memberCheckValue.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...memberCheckValue, value];
    }
    this.setState({
      memberCheckValue: newState,
    });
  }

  handleGroupCheckAll() {
    const { memberChecked, members } = this.state;
    const newState = [];

    if (memberChecked) {
      this.setState({
        memberChecked: false,
        memberCheckValue: [],
      });
    } else {
      const num = members.length;
      let i = 0;
      for (i; i < num; i++) {
        newState.push(i);
      }

      const unique = newState.reduce((a, b) => {
        if (a.indexOf(b) < 0) {
          a.push(b);
        }
        return a;
      }, []);
      this.setState({
        memberChecked: true,
        memberCheckValue: unique,
      });
    }
  }

  handleRemoveProject() {
    const { translate } = this.props;
    const { projectCheckValue, projects } = this.state;
    if (projectCheckValue.length === 0) {
      this.setState({
        modalAlert: true,
        modalAlertMsg: translate('modal.message.select_one_project'),
        modalAlertTitle: translate('modal.title.attention'),
      });
      return false;
    }
    const newState = projects.filter((item, index) => {
      return projectCheckValue.indexOf(index) === -1;
    });
    this.setState({
      projects: newState,
      projectCheckValue: [],
    });
  }

  handleAddProject() {
    this.setState({
      projectChecked: false,
      projectCheckValue: [],
      isOpenMAP: true,
    });
  }

  handleProjectCheckAll() {
    const { projectChecked, projects } = this.state;
    const newState = [];

    if (projectChecked) {
      this.setState({
        projectChecked: false,
        projectCheckValue: [],
      });
    } else {
      const newData = projects.filter((item) => {
        return item.is_project_deletable === true;
      });
      const num = newData.length;
      let i = 0;
      for (i; i < num; i++) {
        newState.push(i);
      }

      const unique = newState.reduce((a, b) => {
        if (a.indexOf(b) < 0) {
          a.push(b);
        }
        return a;
      }, []);
      this.setState({
        projectChecked: true,
        projectCheckValue: unique,
      });
    }
  }

  handleProjectCheckChange(e, { value }) {
    const { projectCheckValue } = this.state;
    let newState;
    if (projectCheckValue.indexOf(value) > -1) {
      newState = projectCheckValue.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...projectCheckValue, value];
    }
    this.setState({
      projectCheckValue: newState,
    });
  }

  getByteLength(text) {
    let l = 0;
    for (let i = 0; i < text.length; i++) l += text.charCodeAt(i) > 128 ? 2 : 1;
    // return text.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, '$&$1$2').length;
    return l;
  }

  getProfileImg(value) {
    const profileImg = `/1/users/me/profile_image/${value}`;

    let baseUrl = '//'.concat(location.hostname);
    let profileImgUrl = '';

    if (process.env.NODE_ENV === 'development') {
      baseUrl = baseUrl.concat(':3000');
    } else {
      baseUrl = location.port !== '' ? baseUrl.concat(':', location.port) : '';
    }

    profileImgUrl = profileImg !== '' ? baseUrl.concat(profileImg) : userPic;

    return profileImgUrl;
  }

  getSLocalGroupDetail(Props) {
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getSLocalGroupDetail(Props.groupId)
        .then((response) => {
          const data = response.response;
          this.setState({
            id: data.id,
            source: data.source,
            groupName: data.group_name,
            description: data.description,
            created: data.created,
            lastModified: data.last_modified,
            members: data.assinged_members,
            projects: data.assinged_projects,
            isNameChangeable: data.is_name_changeable,
            isDescChangeable: data.is_description_changeable,
            isMemberChangeable: data.is_member_changeable,
            isProjectAssignable: data.is_project_assignable,
            isGroupDeletable: data.is_group_deletable,
            isLoading: false,
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  }

  getSGroupMemberDetail = (id, groupArr) => {
    const status = {
      isMemberPopup: true,
      isProjectPopup: false,
    };
    this.setState({
      membersDetail: groupArr,
      activeIndex: id,
      popupStatus: status,
    });
  };

  getSGroupProjectDetail = (id, groupArr) => {
    const status = {
      isMemberPopup: false,
      isProjectPopup: true,
    };
    this.setState({
      projectsDetail: groupArr,
      activeIndex: id,
      popupStatus: status,
    });
  };

  deleteThisUserBtn = () => {
    const { translate } = this.props;
    const { isGroupDeletable } = this.state;
    if (isGroupDeletable) {
      return (
        <a className="red" style={{ cursor: 'pointer', lineHeight: '15px' }} onClick={this.handleRemoveGroup}>
          {translate('modal.button.delete_this_group')}
        </a>
      );
    }
    return (
      <a
        className="red"
        style={{
          pointerEvents: 'none',
          cursor: 'default',
          opacity: '.45',
          lineHeight: '15px',
        }}
      >
        {translate('modal.button.delete_this_group')}
      </a>
    );
  };

  validateFields() {
    const { groupName, isNameChangeable } = this.state;
    const { translate, isLocalSetting } = this.props;

    const validation = {
      groupName: true,
    };

    if (groupName.trim().length === 0) {
      this.setState({
        groupNameError: translate('modal.message.required_group_name')
      });
      this.groupNM.scrollIntoView();
      if (isNameChangeable) {
        this.nameInput.focus();
      }
      validation.groupName = false;
      return false;
    }
    if (this.getByteLength(groupName) > 30 && isLocalSetting) {
      this.setState({
        groupNameError: translate('modal.message.group_name_error')
      });
      this.groupNM.scrollIntoView();
      if (isNameChangeable) {
        this.nameInput.focus();
      }
      validation.groupName = false;
      return false;
    }

    return validation.groupName;
  }

  closeAlertModal() {
    const { translate } = this.props;
    if (this.state.modalAlertTitle.indexOf(translate('modal.title.attention')) > -1) {
      this.setState({
        modalAlert: false,
      });
    } else {
      this.setState(
        {
          modalAlert: false,
        },
        () => {
          this.props.completeCallback(200);
          this.closeEditLocalGroupModal();
        }
      );
    }
  }

  closeEditLocalGroupModal(e) {
    if (typeof e !== 'undefined') {
      if (e === 200) {
        this.setState({
          isOpenMEG: false,
        });
        this.props.closeModal(200);
        return false;
      }
      e.preventDefault();
      if (e.target.classList[0] === 'red_button') {
        return false;
      }
    }
    this.setState({
      isOpenMEG: false,
    });
    this.props.closeModal();
  }

  closeDeleteGroupModal() {
    this.setState({
      isOpenMDG: false,
    });
  }

  convertToString(string) {
    if (string === 'clarityadmin@insignary.com') {
      return 'Admin';
    } if (string === 'licensemanager@insignary.com') {
      return 'Licensemanager';
    }
    return string;
  }

  deleteGroup() {
    api
      .deleteGroup(this.props.groupId)
      .then(() => {
        this.closeDeleteGroupModal();
        this.closeEditLocalGroupModal();
        this.props.completeCallback(200);
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isLoading: false,
        });
      });
  }

  render() {
    const {
      source,
      groupName,
      description,
      created,
      lastModified,
      members,
      projects,
      memberChecked,
      memberCheckValue,
      projectChecked,
      projectCheckValue,
      viewPoint,
      isNameChangeable,
      isDescChangeable,
      isMemberChangeable,
      isProjectAssignable,
      activeIndex,
      isLoading,
    } = this.state;

    const {
      isLocalSetting
    } = this.props;

    const { translate } = this.props;

    const groupNameErrorClass = this.state.groupNameError !== '' ? 'show' : '';

    const getModalContent = () => {
      if (isLoading) {
        return <Loader />;
      }
      return (
        <div className="setting_popup_contnets">
          <div className="setting_popup_content_wrap">
            <h3 className="content_title">{translate('modal.title.type')}</h3>
            <div className="setting_popup_content">
              <div className="text_box">
                {source === 'local' ? (
                  <Label color="green" horizontal>
                    {source}
                  </Label>
                ) : (
                  <Label color="pink" horizontal>
                    {source}
                  </Label>
                )}
              </div>
            </div>
          </div>
          <div className="setting_popup_content_wrap">
            <h3
              className="content_title"
              ref={(ref) => {
                this.groupNM = ref;
              }}
            >
              {translate('settings.list.group_name')}
              <em style={{ marginLeft: '0' }} className="asterisk" />
            </h3>
            {
              isNameChangeable ? (
                <div className="setting_popup_content">
                  <input
                    type="text"
                    value={groupName}
                    placeholder={translate('settings.list.group_name')}
                    onChange={this.handleGroupNameChange}
                    ref={(ref) => {
                      this.nameInput = ref;
                    }}
                    readOnly={!isNameChangeable}
                  />
                  <div
                    className={`error ${groupNameErrorClass}`}
                    style={{
                      marginTop: '6px',
                      marginLeft: '5px',
                      fontSize: '12px',
                      fontWeight: '700',
                      color: '#ef4136',
                    }}
                  >
                    {this.state.groupNameError}
                  </div>
                </div>
              ) : (
                <div className="setting_popup_content">
                  <div className="text_box">{groupName}</div>
                </div>
              )
            }
          </div>
          <div className="setting_popup_content_wrap">
            <h3 className="content_title">{translate('list.title.description')}</h3>
            {
              isDescChangeable ? (
                <div className="setting_popup_content">
                  <textarea
                    value={description}
                    placeholder={translate('list.title.description')}
                    onChange={this.handleDescChange}
                    rows="3"
                    readOnly={!isDescChangeable}
                  />
                </div>
              ) : (
                <div className="setting_popup_content">
                  <div className="text_box">{description}</div>
                </div>
              )
            }
          </div>
          <div className="setting_popup_content_wrap">
            <h3 className="content_title">{translate('settings.list.create_date')}</h3>
            <div className="setting_popup_content">
              <div className="text_box">{created}</div>
            </div>
          </div>
          <div className="setting_popup_content_wrap">
            <h3 className="content_title">{translate('settings.list.last_modified')}</h3>
            <div className="setting_popup_content">
              <div className="text_box">{lastModified}</div>
            </div>
          </div>
          <div className="setting_popup_content_wrap">
            <h3
              className="content_title"
              ref={(ref) => {
                this.groupMB = ref;
              }}
            >
              {translate('settings.list.group_member')}
              (
              {members.length}
              )
              {isMemberChangeable ? (
                <div className="button_box">
                  <a
                    className="delete_button"
                    onClick={this.handleRemoveMember}
                    style={{ cursor: 'pointer' }}
                  >
                    {translate('modal.button.delete')}
                  </a>
                  <a
                    className="add_button"
                    onClick={this.handleAddMember}
                    style={{ cursor: 'pointer' }}
                  >
                    {translate('modal.button.add')}
                  </a>
                </div>
              ) : (
                <div className="button_box">
                  <a
                    className="delete_button"
                    style={{
                      pointerEvents: 'none',
                      cursor: 'default',
                      opacity: '.45',
                    }}
                  >
                    {translate('modal.button.delete')}
                  </a>
                  <a
                    className="add_button"
                    style={{
                      pointerEvents: 'none',
                      cursor: 'default',
                      opacity: '.45',
                    }}
                  >
                    {translate('modal.button.add')}
                  </a>
                </div>
              )}
            </h3>
            {members.length !== 0 ? (
              <div className="setting_popup_content">
                <div className="table_wrap table_type_3">
                  <table className="table table_type_3">
                    <colgroup>
                      <col style={{ width: '36px' }} />
                      <col style={{ width: '' }} />
                      <col style={{ width: '230px' }} />
                      <col style={{ width: '150px' }} />
                      <col style={{ width: '100px' }} />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          {isMemberChangeable ? (
                            <Checkbox
                              checked={memberChecked}
                              onChange={this.handleGroupCheckAll}
                            />
                          ) : null}
                        </th>
                        <th>{translate('modal.title.name')}</th>
                        <th>{translate('modal.title.email')}</th>
                        <th className="tac">{translate('modal.title.assigned_group')}</th>
                        <th className="tar">{translate('modal.title.assigned')}</th>
                      </tr>
                      {members.map((list, index) => {
                        return (
                          <tr key={uuidv4()}>
                            <td>
                              {isMemberChangeable ? (
                                <Checkbox
                                  value={index}
                                  checked={memberCheckValue.indexOf(index) > -1}
                                  onChange={this.handleGroupCheckChange}
                                />
                              ) : null}
                            </td>
                            <td>
                              <span className="user_icon">
                                <img
                                  src={this.getProfileImg(list.id)}
                                  alt=""
                                  style={{ width: '17px', height: '17px', borderRadius: '50%' }}
                                />
                                {list.profile}
                              </span>
                            </td>
                            <td>{this.convertToString(list.email)}</td>
                            {list.groups.length === 0 ? (
                              <td>{list.groups.length}</td>
                            ) : (
                              <Popup
                                trigger={
                                  <td style={{ cursor: 'pointer' }}>{list.groups.length}</td>
                                }
                                on="click"
                                hideOnScroll
                                position="bottom left"
                                open={
                                  this.state.popupStatus.isMemberPopup
                                  && activeIndex === list.id
                                }
                                onOpen={() => {
                                  return this.getSGroupMemberDetail(list.id, list.groups);
                                }}
                                onClose={this.handleClose}
                              >
                                <List>
                                  {this.state.membersDetail.map((item) => {
                                    return (
                                      <List.Item key={uuidv4()}>
                                        <List.Icon name="group" />
                                        <List.Content>{item}</List.Content>
                                      </List.Item>
                                    );
                                  })}
                                </List>
                              </Popup>
                            )}
                            <td className="tar">{list.assigned || '-'}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : null}
          </div>
          <div className="setting_popup_content_wrap">
            <h3 className="content_title">
              {translate('settings.list.assigned_project')}
              (
              {projects.length}
              )
              {isProjectAssignable ? (
                <div className="button_box">
                  <a
                    className="delete_button"
                    onClick={this.handleRemoveProject}
                    style={{ cursor: 'pointer' }}
                  >
                    {translate('modal.button.delete')}
                  </a>
                  <a
                    className="add_button"
                    onClick={this.handleAddProject}
                    style={{ cursor: 'pointer' }}
                  >
                    {translate('modal.button.add')}
                  </a>
                </div>
              ) : (
                <div className="button_box">
                  <a
                    className="delete_button"
                    style={{
                      pointerEvents: 'none',
                      cursor: 'default',
                      opacity: '.45',
                    }}
                  >
                    {translate('modal.button.delete')}
                  </a>
                  <a
                    className="add_button"
                    style={{
                      pointerEvents: 'none',
                      cursor: 'default',
                      opacity: '.45',
                    }}
                  >
                    {translate('modal.button.add')}
                  </a>
                </div>
              )}
            </h3>
            {projects.length !== 0 ? (
              <div className="setting_popup_content">
                <div className="table_wrap table_type_3">
                  <table className="table table_type_3">
                    <colgroup>
                      <col style={{ width: '36px' }} />
                      <col style={{ width: '' }} />
                      <col style={{ width: '150px' }} />
                      <col style={{ width: '130px' }} />
                      <col style={{ width: '100px' }} />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          <Checkbox
                            checked={projectChecked}
                            onChange={this.handleProjectCheckAll}
                          />
                        </th>
                        <th>{translate('modal.title.project_name')}</th>
                        <th>{translate('modal.title.project_group')}</th>
                        <th>{translate('modal.title.project_owner')}</th>
                        <th className="tar">{translate('modal.title.assigned')}</th>
                      </tr>
                      {projects.map((list, index) => {
                        return (
                          <tr key={uuidv4()}>
                            <td>
                              <Checkbox
                                value={index}
                                checked={projectCheckValue.indexOf(index) > -1}
                                onChange={this.handleProjectCheckChange}
                                disabled={list.is_project_deletable === false}
                              />
                            </td>
                            <td>{list.name}</td>
                            {list.groups.length === 0 ? (
                              <td>{list.groups.length}</td>
                            ) : (
                              <Popup
                                trigger={
                                  <td style={{ cursor: 'pointer' }}>{list.groups.length}</td>
                                }
                                on="click"
                                hideOnScroll
                                position="bottom left"
                                open={
                                  this.state.popupStatus.isProjectPopup
                                  && activeIndex === list.id
                                }
                                onOpen={() => {
                                  return this.getSGroupProjectDetail(list.id, list.groups);
                                }}
                                onClose={this.handleClose}
                              >
                                <List>
                                  {this.state.projectsDetail.map((item) => {
                                    return (
                                      <List.Item key={uuidv4()}>
                                        <List.Icon name="group" />
                                        <List.Content>{item}</List.Content>
                                      </List.Item>
                                    );
                                  })}
                                </List>
                              </Popup>
                            )}
                            <td>{this.convertToString(list.owner)}</td>
                            <td className="tar">{list.assigned || '-'}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : null}
          </div>
          <div className="setting_popup_bottom">{this.deleteThisUserBtn()}</div>
        </div>
      );
    };

    return (
      <Modal open={this.state.isOpenMEG} onClose={this.closeEditLocalGroupModal}>
        <div className="setting_popup default_popup" style={{ paddingTop: '140px' }}>
          <div className="setting_popup_header">
            <h2 className="popup_name">{isLocalSetting ? translate('settings.list.local_group_detail') : translate('settings.list.ldap_group_detail')}</h2>
            <a className="popup_close_button" onClick={this.closeEditLocalGroupModal}>
              <img src={closeBtn} alt="" />
            </a>
            <div className="popup_inner_menu">
              <a
                className={cx({
                  active: viewPoint === '1',
                })}
                data-id="1"
                onClick={this.handleViewPostion}
              >
                {translate('modal.title.group_information')}
              </a>
              <a
                className={cx({
                  active: viewPoint === '2',
                })}
                data-id="2"
                onClick={this.handleViewPostion}
              >
                {translate('settings.list.group_member')}
                (
                {members.length}
                )
              </a>
            </div>
          </div>
          <Scrollbars
            style={{
              position: 'relative',
              overflow: 'hidden',
              height: '100%',
            }}
            onScroll={this.handleScroll}
          >
            {getModalContent()}
          </Scrollbars>
          {
            isLoading ? null : (
              <div className="setting_popup_button_wrap">
                <a
                  className="button cencel_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.closeEditLocalGroupModal}
                >
                  {translate('modal.button.cancel')}
                </a>
                <a
                  className="button save_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.handleSave}
                >
                  {translate('modal.button.save')}
                </a>
              </div>
            )
          }
        </div>
        <AssigningUserModal
          isOpenMAU={this.state.isOpenMAU}
          isOpenMEG={this.state.isOpenMEG}
          closeModal={this.handleMAUClose}
          completeCallback={this.handleMemberList}
          members={members}
          translate={translate}
        />
        <AssigningProjectModal
          isOpenMAP={this.state.isOpenMAP}
          isOpenMEG={this.state.isOpenMEG}
          closeModal={this.handleMAPClose}
          projects={projects}
          completeCallback={this.handleProjectList}
          translate={translate}
        />
        <Modal open={this.state.modalAlert} onClose={this.closeAlertModal}>
          {this.state.isLoader ? (
            <Loader />
          ) : (
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                <div className="modal_popup confirm">
                  <h2 className="title">{this.state.modalAlertTitle}</h2>
                  <p className="text">{this.state.modalAlertMsg}</p>
                  <div className="button_wrap">
                    <a onClick={this.closeAlertModal} className="center_button">
                      {translate('modal.button.ok')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal>
        <Modal open={this.state.isOpenMDG} onClose={this.closeDeleteGroupModal}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{translate('modal.title.attention')}</h2>
                <p className="text">{translate('settings.message.delete_group')}</p>
                <p
                  className="small_text"
                  style={{ whiteSpace: 'break-spaces' }}
                >
                  {translate('settings.message.delete_group_confirm')}

                </p>
                <div className="button_wrap">
                  <a onClick={this.closeDeleteGroupModal} className="left_button">
                    {translate('modal.button.cancel')}
                  </a>
                  <a onClick={this.deleteGroup} className="right_button">
                    {translate('modal.button.delete')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </Modal>
    );
  }
}

export default EditLocalGroupModal;
